import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import HeaderProfile from "./HeaderProfile";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "../../assets/theme";
import "../../assets/base.css";

// The shortcode can be placed more than once (e.g. desktop and mobile header).
document.querySelectorAll(".tmt-header-profile").forEach((rootElement) => {
	createRoot(rootElement).render(
		<StrictMode>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<HeaderProfile />
			</ThemeProvider>
		</StrictMode>
	);
});
